import { types, getParent, flow } from 'mobx-state-tree';
import { OceanCarrierRow } from './models';
import { resolvePaginationStore } from '../PaginationStore';

const OceanCarriersStore = types
  .model('OceanCarriersStore', {
    oceanCarriers: types.array(OceanCarrierRow),
    pagination: types.optional(
      resolvePaginationStore({
        onChangePerPage: (self) => getParent(self).loadOceanCarriers(),
        onChangePage: (self, page) => getParent(self).loadOceanCarriers({ page }),
      }),
      {
        perPage: 50
      },
    ),
  })
  .volatile(self => ({
    loading: false,
  }))
  .views(self => ({
    get root() {
      return getParent(self);
    },
  }))
  .actions(self => ({
    loadOceanCarriers: flow(function* ({ page = 1 } = {}) {
      try {
        self.loading = true;
        const response = yield self.root.api.oceanCarrier.index({ page: page, per_page: self.pagination.perPage });
        self.oceanCarriers = response.data.data;
        self.pagination.setFromMeta(response.data.meta);
      } catch (error) {
        self.root.ui.toast.error(error);
      }
      self.loading = false;
    }),
    destroy: flow(function* (id) {
      let response;
      if (window.confirm('Are you sure to delete it?')) {
        try {
          self.loading = true;
          response = yield self.root.api.oceanCarrier.destroy(id);
          self.loadOceanCarriers();
        } catch (error) {
          self.root.ui.toast.error(error);
        }
        self.loading = false;
      }
    }),
  }))


export default OceanCarriersStore;
